import { Switch as MuiSwitch, type SwitchProps as MuiSwitchProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiSwitchProps, 'slots' | 'icon' | 'checkedIcon'>>;

export function Switch(props: Props) {
  return <MuiSwitch {...props} />;
}

export type { Props as SwitchProps };
